import React, { useState } from "react";
import { API_BASE_URL } from "../../utils/constants";
import { readErrorMessage } from "../../utils/apiError";

// The uploaded Word file still has Track Changes edits waiting: one click accepts them all (like Word's
// Review → Accept All Changes), so the letters print the final text only
const AcceptChanges = ({ upload, onAccepted }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!upload?.trackedChanges) return null;

  const accept = async () => {
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/api/doc-templates/uploads/${upload.id}/accept-changes`, { method: "POST" });
      if (!res.ok) throw new Error(await readErrorMessage(res));
      onAccepted(await res.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-2 mb-2 bg-white border rounded">
      <div className="fw-semibold mb-1">Edits waiting in Track Changes</div>
      <div className="text-muted mb-2">
        Someone edited this Word file with Track Changes on, and {upload.trackedChanges} edit
        {upload.trackedChanges === 1 ? " is" : "s are"} still waiting to be accepted. Accepting keeps the text as it reads
        now in Word: crossed-out words are removed, new words stay.
      </div>
      {error && <div className="text-danger mb-1">{error}</div>}
      <button type="button" className="btn btn-sm btn-primary" disabled={busy} onClick={accept}>
        {busy ? "Accepting…" : "Accept all changes"}
      </button>
    </div>
  );
};

export default AcceptChanges;
